import ExpiredStorage from "expired-storage"

const MAX_MEDIA_TO_SHARE = 10
const LOCAL_STORAGE_KEY = 'share_images_list'
const LOCAL_STORAGE_EXPIRES_IN = 28800 // 8 hours in seconds (60 * 60 * 8)
const storage = new ExpiredStorage()

export const mediaListFromLocalStorage = () => {
  if (!storage) return []

  return storage.getJson(LOCAL_STORAGE_KEY) || []
}

export const purgeMediaListFromLocalStorage = () => {
  if (!storage) return

  storage.removeItem(LOCAL_STORAGE_KEY)
}

const syncMediaListInLocalStorage = (list) => {
  if (!storage) return

  storage.setJson(LOCAL_STORAGE_KEY, list, LOCAL_STORAGE_EXPIRES_IN) 
}

export const state = () => ({
  mediaList: [],
  cartOpen: false
})

export const mutations = {
  addMedium(state, medium) {
    if (state.mediaList.find(({ id }) => id === medium.id)) return

    state.mediaList = [...state.mediaList, medium]
    syncMediaListInLocalStorage(state.mediaList)
  },

  removeMedium(state, medium) {
    state.mediaList = state.mediaList.filter(({ id }) => id !== medium.id)
    syncMediaListInLocalStorage(state.mediaList)
  },

  resetMediaList(state) {
    state.mediaList = []
    syncMediaListInLocalStorage(state.mediaList)
  },

  setMediaList(state, mediaList) {
    state.mediaList = [...mediaList]
  },

  setCartOpen(state, isOpen) {
    state.cartOpen = isOpen
  }
}

export const actions = {
  addMediumToList({ state, commit }, medium) {
    return new Promise((resolve, reject) => {
      if (state.mediaList.length < MAX_MEDIA_TO_SHARE) {
        commit('addMedium', medium)
        resolve()
      }
      else {
        reject(new Error('Maximum cart size reached'))
      }
    })
  },

  openCart({ commit }) { commit('setCartOpen', true) },

  closeCart({ commit }) { commit('setCartOpen', false) }
}

export const getters = {
  mediaList(state) { return state.mediaList },

  mediumPresent: (state) => ({ id }) => state.mediaList.map(m => m.id).includes(id),

  mediaCount(state) { return state.mediaList.length },

  cartOpen(state) { return state.cartOpen }
}
